"use client";

import { AfterLoginHeader } from "@/components/Header/AfterLoginHeader";
import { isMobileViewHook } from "@/customHooks/isMobileViewHook";
import { cn } from "@/utils";
import moment from "moment";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { GiHamburgerMenu } from "react-icons/gi";
import Drawer from "react-modern-drawer";
import { useLocation } from "react-router-dom";
import SideBar from "../SideBar";
import classes from "./SideBarSkeleton.module.css";
const SideBarSkeleton = ({
  children,
  footerVisible = false,
  headerHeading,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  useEffect(() => {
    isMobileViewHook((e) => {
      setIsMobile(e);
      if (e) {
        setIsCollapsed(false);
      }
    }, 1040);
  }, []);

  return (
    <>
      <style>{`
        .drawerContainer{
          width:320px !important;
          background-color:transparent !important;
        }
        @media (max-width:768px){
          .drawerContainer{
            width:290px !important;
          }
        }
    `}</style>
      <Container
        fluid
        className="g-0"
        style={{ backgroundColor: "var(--background)" }}
      >
        <div className={`${classes.wrapper} g-0`}>
          <div
            className={[
              !isMobile ? classes.sidebarDiv : classes.sidebarOnMobileDiv,
              isCollapsed ? classes.iscollapsed : "",
            ].join(" ")}
          >
            {!isMobile ? (
              <SideBar
                isCollapsed={isCollapsed}
                setIsCollapsed={setIsCollapsed}
              />
            ) : (
              <Drawer
                open={isOpen}
                onClose={toggleDrawer}
                direction="left"
                className="drawerContainer"
              >
                <SideBar
                  isCollapsed={isCollapsed}
                  setIsCollapsed={setIsCollapsed}
                  isMobile={isMobile}
                />
              </Drawer>
            )}
          </div>
          <div
            className={[
              !isMobile ? classes.contentDiv : classes.contentOnMobileDiv,
              isCollapsed ? classes.contentIsCollapsed : "",
            ].join(" ")}
          >
            <AfterLoginHeader
              drawerBtn={
                isMobile && (
                  <GiHamburgerMenu
                    className={[classes.GiHamburgerMenuMobile]}
                    onClick={() => {
                      toggleDrawer();
                    }}
                  />
                )
              }
              header={headerHeading}
            />
            <div className={cn(classes.pageMain, classes.noPageBg)}>
              {children}
            </div>
          </div>
          {footerVisible && (
            <div className={classes.footer}>
              <p>Copyright {moment().format("YYYY")}, All Rights Reserved</p>
              <div className={classes.links}>
                <a href="/privacy-policy">Privacy Policy</a>
                <span className={classes.seprator}></span>
                <a href="/terms-and-conditions">Terms &amp; Conditions</a>
              </div>
            </div>
          )}
        </div>
      </Container>
    </>
  );
};

export default SideBarSkeleton;
